module.exports = __webpack_public_path__ + "static/img/06.3d0a0ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/06.png
// module id = YXCc
// module chunks = 1